module.exports = __webpack_public_path__ + "img/6.bd635aaf.jpg";